<template>
  <div class="app-container courseware">
    <div class="courseware-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="courseware-filter-value" v-model.trim="filter.keyword" @keyup.enter.native="handleConfirmFilter" placeholder="名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select
            class="courseware-filter-value"
            v-model="filter.type"
            placeholder="类型"
            clearable
            size="small">
            <el-option
              v-for="item in coursewareTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-select v-model="filter.coursewareGroupId" size="small" placeholder="分组">
              <el-option
                v-for="item in coursewareGroups"
                :key="item.id"
                :label="item.groupName"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="courseware-filter-reset" size="small" @click="handleClearFilter">清除条件</el-button>
            <el-button class="courseware-filter-search" size="small" @click="handleConfirmFilter">立即筛选</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container>
      <avue-crud :table-loading="listLoading"
                 :data="list" 
                 :option="tableOption" 
                 :page="page" 
                 @size-change="sizeChange"
                 @current-change="currentChange"
                 @on-load="getCoursewareList" 
                 @sort-change="handleSortChange">
      <template slot="menuLeft">
        <el-button
          v-if="permissions.courseware_add"
          class="filter-item"
          @click="handleAdd()"
          size="small"
          type="primary"
          icon="el-icon-plus">新增
        </el-button>
      </template>
      <template slot="name" slot-scope="scope">
        <span class="c-primary click" @click="handleView(scope.row)">{{scope.row.name}}</span>
      </template>
      <template slot="coursewareGroupId" slot-scope="scope">
        <span>{{formatCourseGroup(coursewareGroups, scope.row.coursewareGroupId)}}</span>
      </template>
      <template slot="coursewareLength" slot-scope="scope">
        <span>{{formatCoursewareLength(scope.row.type, scope.row.coursewareLength)}}</span>
      </template>
      <template slot="coursewareTime" slot-scope="scope">
        <span>{{formatTime(scope.row.coursewareTime)}}</span>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          v-if="permissions.courseware_detail"
          size="mini"
          type="text"
          @click="handleView(scope.row)">查看
        </el-button>

        <el-button
          v-if="permissions.courseware_update"
          size="mini"
          type="text"
          @click="handleEdit(scope.row)">编辑
        </el-button>

        <el-button
          v-if="permissions.courseware_delete"
          size="mini"
          type="text"
          @click="handleDelete(scope.row)">删除
        </el-button>
      </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
import { coursewarelistTableOption as tableOption, coursewareTypeOptions } from '@/const/crud/app/course'
import { fetchCoursewareList, removeCoursewareById } from '@/api/app/course'
import { formatCourseGroup, formatCoursewareLength, formatTime } from './util/index';
import { fetchCoursewareGroupList } from '@/api/app/course';
import { requestWrapper } from '@/util/util';
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      tableOption,
      coursewareTypeOptions,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      filter: {
        keyword: '',
        type: undefined,
        coursewareGroupId: undefined,
        sortField: 'inserted_time',
        sortPolicy: 'desc',
      },
      listLoading: true,
      list: [],
      coursewareGroups: [],
    }
  },
  computed: {
    ...mapGetters(['permissions'])
  },
  activated: async function() {
    const res = await requestWrapper(fetchCoursewareGroupList);
    if (!res.ok) {
      this.$message.error('获取课件分组失败')
    } else {
      this.coursewareGroups = res.data;
    }
    this.getCoursewareList(this.page);
  },
  methods: {
    formatCourseGroup,
    formatCoursewareLength,
    formatTime,
    handleAdd() {
      this.$router.push('/app/course/courseware/add');
    },
    handleEdit(row) {
      this.$router.push(`/app/course/courseware/edit/${row.id}`);
    },
    handleView(row) {
      this.$router.push(`/app/course/courseware/${row.id}`);
    },
    async getCoursewareList(page) {
      this.listLoading = true;
      let params = {};
      params.size = page.pageSize;
      params.current = page.currentPage;
      params.keyword = this.filter.keyword;
      params.type = this.filter.type;
      params.coursewareGroupId = this.filter.coursewareGroupId;

      if(this.filter.sortField !== "" && this.filter.sortField.trim() !== "")
        params.sortField = this.filter.sortField;
      else
        params.sortField="inserted_time";
      if(this.filter.sortPolicy !== "" && this.filter.sortPolicy.trim() !== "")
        params.sortPolicy = this.filter.sortPolicy;
      else
        params.sortPolicy="desc";

      const response = await fetchCoursewareList(params);

      this.list = response.data.data.records;
      this.page.total = response.data.data.total;
      this.listLoading = false;
    },
    handleSortChange(val) {
      if (val.prop == "insertedTime") {
        this.filter.sortField = "inserted_time";
      } else {
        this.filter.sortField = "";
      }
      if (val.order == 'ascending') {
        this.filter.sortPolicy = "asc";
      } else if (val.order == 'descending') {
        this.filter.sortPolicy = "desc";
      } else {
        this.filter.sortPolicy = "";
      }
      this.getCoursewareList(this.page);
    },
    handleDelete(row) {
      this.$confirm(`您是否确定删除"${row.name}"课件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await requestWrapper(removeCoursewareById, row.id);
        if (res.code === 0) {
          this.$message.success('删除成功');
          this.getCoursewareList(this.page);
        } else {
          this.$message({
            showClose: true,
            message: res.msg || '删除失败',
            type: 'error',
          });
        }
      });
    },
    handleClearFilter() {
      this.filter.keyword = '';
      this.filter.type = undefined;
      this.filter.coursewareGroupId = undefined;
      this.handleConfirmFilter();
    },
    handleConfirmFilter() {
      this.page.currentPage = 1;
      this.getCoursewareList(this.page);
    },
    sizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
    },
    currentChange(val) {
      this.page.currentPage = val;
    },
  }
}
</script>

<style lang="scss" scoped>
.courseware {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    &-button {
      color: #5383f3;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
.click {
  cursor: pointer;
}
</style>
